import { mapActions, mapGetters, mapMutations } from 'vuex'

import { productMovesUtil, currencyUtil, commonUtil } from '@/util'

import DisplaySwitchButton from '@/components/items/Buttons/DisplaySwitchButton'
import HelpCircle from '@/components/items/Buttons/HelpCircle'
import ProductTable from '@/components/items/Tables/ProductTable'
import HoverPopSummary from '@/components/layouts/HoverPop/HoverPopSummary'

import {
  OrderRowInfo,
  OrderRowInfoDetail,
  OrderBulkOperationButtons
} from './Pages/Order'

import {
  SalesRowInfo,
  SalesRowInfoDetail,
  SalesBulkOperationButtons
} from './Pages/Sales'

import {
  ShipRowInfo,
  ShipRowInfoDetail,
  ShipBulkOperationButtons
} from './Pages/Ship'

import {
  LoadingRowInfo,
  LoadingRowInfoDetail,
  LoadingBulkOperationButtons
} from './Pages/Loading'

import { ChangeRowInfo, ChangeRowInfoDetail } from './Pages/Change'

import {
  StockAdjustRowInfo,
  StockAdjustRowInfoDetail
  // StockAdjustBulkOperationButtons
} from './Pages/StockAdjust'

import {
  CsvRowInfo,
  CsvRowInfoDetail,
  CsvBulkOperationButtons
} from './Pages/Csv'

import { StockMoveRowInfo, StockMoveRowInfoDetail } from './Pages/StockMove'

import { RefundRowInfo, RefundRowInfoDetail } from './Pages/Refund'

import { InvoiceDialog } from '@/components/layouts/Dialogs'

import mutationTypes from '@/store/mutationTypes'

import TotalAmount from '@/components/items/Designs/TotalAmount/TotalAmount'

export default {
  name: 'HistoryList',
  components: {
    DisplaySwitchButton,
    HelpCircle,
    ProductTable,

    SalesRowInfo,
    SalesRowInfoDetail,
    SalesBulkOperationButtons,

    OrderRowInfo,
    OrderRowInfoDetail,
    OrderBulkOperationButtons,

    LoadingRowInfo,
    LoadingRowInfoDetail,
    LoadingBulkOperationButtons,

    ChangeRowInfo,
    ChangeRowInfoDetail,

    ShipRowInfo,
    ShipRowInfoDetail,
    ShipBulkOperationButtons,

    StockAdjustRowInfo,
    StockAdjustRowInfoDetail,
    // StockAdjustBulkOperationButtons,

    CsvRowInfo,
    CsvRowInfoDetail,
    CsvBulkOperationButtons,

    StockMoveRowInfo,
    StockMoveRowInfoDetail,

    RefundRowInfo,
    RefundRowInfoDetail,

    HoverPopSummary,
    InvoiceDialog,
    TotalAmount
  },
  props: {
    isOperation: { default: false },
    summary: {
      type: Object,
      require: false,
      default: () => ({})
    },
    historyList: {
      type: Array,
      require: true,
      default: () => []
    },
    itemKey: '',

    headers: {
      type: Array,
      require: true,
      default: () => []
    },
    productListHeaders: {
      type: Array,
      require: true,
      default: () => []
    },
    isFooter: { type: Boolean, default: false },
    isChangeHistory: { type: Boolean, default: false },
    hiddenHeaderOperation: { type: Boolean, default: false },
    pagerKey: {
      type: String,
      default: ''
    },
    isCheckedAllSelect: { default: false },
    saleDate: {
      type: Object,
      require: false,
      default: () => ({
        start: null,
        end: null
      })
    },

    // customerList: {
    //   default: {}
    // }
  },
  data: () => ({
    openPanelIndex: [],
    allChangeCheckBox: false,
    productInfoData: [],
    selectRowInfo: {
      selectRowlength: 0,
      sumAmount: 0,
      unit: ''
    },

    operationName: '',
    matchedOperationName: '',
    isBatch: false,

    currencyAmountSelect: [],
    currencyAmount: [],

    componentNames: {
      BulkOperationButtons: '',
      RowInfo: '',
      RowInfoDetail: ''
    },
    customerList: [],
    supplierList: [],

    dialogParams: {
      dialog: false,
      type: '',
      items: null,
      submitPath: '',
      submitFunc: () => {}
    }
  }),
  // beforeMount() {
  //    this.setProductInfoData()
  // },
  async created() {
    this.setComponentName()
    this.ini()
  },
  methods: {
    ...mapActions('Customer', ['getCustomersFromApi']),
    ...mapGetters('Customer', ['getCustomerListFromState']),

    ...mapActions('Supplier', ['getSuppliersFromApi']),
    ...mapGetters('Supplier', ['getSuppliersFromState']),

    ...mapActions('Sale', ['sendMailSalesCSV']),
    ...mapActions('Order', ['sendMailOrderCSV']),

    ...mapMutations('UI', [mutationTypes.UI_SET_PAGE]),

    ...mapActions('Ship', ['fileUpload']),

    setComponentName() {
      ;['BulkOperationButtons', 'RowInfo', 'RowInfoDetail'].map((ele) => {
        this.componentNames[ele] = this.getComponentName(ele)
      })
    },
    getComponentName(type) {
      return this.getFolderName() + type
    },
    getFolderName() {
      let ret = ''
      switch (this.itemKey) {
        case 'saleId': {
          ret = 'Sales'
          break
        }
        case 'orderId': {
          ret = 'Order'
          break
        }
        case 'loadingId': {
          ret = 'Loading'
          break
        }
        case 'changeId': {
          ret = 'Change'
          break
        }
        case 'shipId': {
          ret = 'Ship'
          break
        }
        case 'stockAdjustId': {
          ret = 'StockAdjust'
          break
        }
        case 'storageMoveId': {
          ret = 'StockMove'
          break
        }
        case 'refundId': {
          ret = 'Refund'
          break
        }
        case 'csvId': {
          ret = 'Csv'
          break
        }
      }
      return ret
    },

    ini() {
      switch (this.itemKey) {
        case 'saleId': {
          this.isBatch = true
          this.operationName = this.$t('sale.sale_number-of-sales')
          this.matchedOperationName = this.$t('sale.sale_product-sale-quantity')
          // await this.getCustomersFromApi()
          // this.customerList = this.getCustomerNameList()
          break
        }
        case 'orderId': {
          this.isBatch = true
          this.operationName = this.$t('common.input_order-quantity')
          this.matchedOperationName = this.$t(
            'order.order_product-order-quantity'
          )
          // await this.getSuppliersFromApi()
          // this.supplierList = this.getSupplierNameList()
          break
        }
      }
    },

    // create Name List
    getCustomerNameList(newVal) {
      return this.getCustomerListFromState().map((rec) => {
        return { label: rec.organizationName, value: rec.customerId }
      })
    },
    getSupplierNameList() {
      return this.getSuppliersFromState().map((ele) => {
        return {
          label: ele.name,
          value: ele.supplierId
        }
      })
    },

    panelClick(index) {
      this.openPanelIndex.find((ele) => ele === index)
        ? (this.openPanelIndex = this.openPanelIndex.filter(
            (ele) => ele !== index
          ))
        : this.openPanelIndex.push(index)
    },

    getProductInfoData(id) {
      return this.productInfoData.find((ele) => ele.id === id)
    },
    formatPrice(price) {
      return commonUtil.formatPrice(price)
    },
    // getTotalInfo() {
    //   const sumAmount = this.productInfoData.reduce(
    //     (accumulator, currentValue, currentIndex, array) => {
    //       const count = currentValue.sumAmount
    //       return accumulator + count
    //     },
    //     0
    //   )
    //   return {
    //     count: this.historyList.length,
    //     sumAmount: sumAmount
    //   }
    // },
    setProductInfoData() {
      const currencyId = currencyUtil.findCurrencyNameById(
        this.summary.currencyId
      )
      this.selectRowInfo.unit = currencyId ? currencyId.unitName : ''

      this.currencyAmount = Array.isArray(this.summary.currencyAmount)
        ? this.summary.currencyAmount
        : []

      this.productInfoData = this.historyList.map((ele) => {
        if (ele.productMoves === undefined) {
          return {}
        }
        const priceForCostAmount =
          productMovesUtil.getTotalPriceForCostAmount(ele.productMoves) +
          Number(ele.consumptionTax10TaxDeclaredCurrency) +
          Number(ele.consumptionTax8TaxDeclaredCurrency) +
          Number(ele.comissionTaxDeclaredCurrency) -
          Number(ele.discountTaxDeclaredCurrency)

        const priceForEachCurrency = this.getAmountForEachHistory(ele)

        return {
          id: ele[this.itemKey],
          checkFlg: false,
          shipDate: ele.shipDate,
          priceForCostAmount: priceForCostAmount,
          sumAmount: this.getAmount(ele[this.itemKey]),
          priceForEachCurrency: priceForEachCurrency,
          currencyId: ele.currencyId,
          customerId: ele.customerId,
          status: ele.status
        }
      })

      this.updateProductInfoData()
    },
    updateProductInfoData() {
      const selectList = this.productInfoData.filter((ele) => ele.checkFlg)

      this.currencyAmountSelect = !Array.isArray(this.currencyAmount)
        ? []
        : this.currencyAmount.map((ele) => {
            const amount = selectList.reduce(
              (accumulator, currentValue, currentIndex, array) => {
                const count =
                  ele.currencyId === currentValue.currencyId
                    ? currentValue.priceForEachCurrency
                    : 0

                return accumulator + count
              },
              0
            )
            return {
              currencyId: ele.currencyId,
              amount: amount ? amount : 0
            }
          })
    },
    getCurrencyAmount(list, currencyId) {
      return
    },

    getAmount(id) {
      return this.historyList
        .find((ele) => ele[this.itemKey] === id)
        .productMoves.reduce(
          (accumulator, currentValue, currentIndex, array) => {
            const count =
              !currentValue.priceForCostInfo || !currentValue.quantity
                ? ''
                : currentValue.priceForCostInfo.cost * currentValue.quantity
            return accumulator + count
          },
          0
        )
    },
    getAmountForEachHistory(rec) {
      const ret = productMovesUtil.getTotalAmountAndUnit(
        rec.productMoves,
        rec.currencyId
      )
      const addAmount =
        Number(rec.consumptionTax10) +
        Number(rec.consumptionTax8) -
        Number(rec.discount) +
        Number(rec.comission)
      const amount = ret.amount + addAmount

      return amount
    },

    changeCheckBoxCommon() {
      this.setSelectRowlength()
      this.setPriceForCostAmount()
    },
    changeAllCheckBox(bool) {
      this.productInfoData.map((ele) => {
        ele.checkFlg = bool
        return ele
      })
      this.changeCheckBoxCommon()
    },
    changeProductTableCheckbox() {
      this.$emit('changeProductTableCheckbox')
    },
    allCheckProductTable() {
      this.$emit('allCheckProductTable')
    },
    setSelectRowlength() {
      const count = this.productInfoData.reduce(
        (accumulator, currentValue, currentIndex, array) => {
          const count = currentValue.checkFlg ? 1 : 0
          return accumulator + count
        },
        0
      )
      this.selectRowInfo.selectRowlength = count
      this.allChangeCheckBox = this.productInfoData.length === count
    },
    setPriceForCostAmount() {
      const count = this.productInfoData.reduce(
        (accumulator, currentValue, currentIndex, array) => {
          const count = currentValue.checkFlg
            ? currentValue.priceForCostAmount
            : 0
          return accumulator + count
        },
        0
      )
      this.selectRowInfo.sumAmount = count
    },

    rowDialogMethodCommon(...args) {
      this.$emit('rowDialogMethodCommon', ...args)
    },
    dialogReload() {
      this.$emit('dialogReload')
    },
    getLedgerSheet(path) {
      const baseUrl = process.env.VUE_APP_WEB_API_BASE_URL
      const url = `${baseUrl}${path}`
      window.open(url, '_blank')
    },
    onClickLedgerSheet(type, items) {
      let path = ''
      switch (type) {
        case 'purchaseOrder': {
          // 発注書
          if (!items.length) {
            const { orderId } = items
            path = `/api/order/ledger-sheet/purchase-order?orderIds=${orderId}`
          } else {
            const ids = items.map((d) => d.id).join(',')
            path = `/api/order/ledger-sheet/purchase-order?orderIds=${ids}`
          }
          break
        }
        case 'deliverySlip': {
          // 納品書
          const { shipId } = items
          path = `/api/order/ledger-sheet/delivery-slip?shipIds=${shipId}`
          break
        }
        case 'quotation':
        case 'bill': {
          // 見積書
          // 請求書（指定なし）
          if (!items.length) {
            const { saleId } = items
            path = `/api/order/ledger-sheet/${type}?saleIds=${saleId}`
          } else {
            const ids = items.map((d) => d.id).join(',')
            path = `/api/order/ledger-sheet/${type}?saleIds=${ids}`
          }
          break
        }
        case 'account':
        case 'refund': {
          this.dialogParams.dialog = true
          this.dialogParams.type = type
          this.dialogParams.items = items
          this.dialogParams.submitPath = '/api/order/ledger-sheet/bill'
          this.dialogParams.submitFunc = this.getLedgerSheet
          return
        }
        case 'combinedBill': {
          // 注文日のバリデーションチェック
          if (
            (!this.saleDate.start && this.saleDate.end) ||
            (this.saleDate.start && !this.saleDate.end)
          ) {
            alert(this.$t('sale.sale_order-date-required'))
            return
          }

          // 顧客IDがすべて同一かチェック
          const customerIds = items.map((item) => item.customerId)
          const allSameCustomer = customerIds.every(
            (id) => id === customerIds[0]
          )
          if (!allSameCustomer) {
            alert(this.$t('sale.sale_customer-must-be-same'))
            return
          }

          // 通貨IDがすべて同一かチェック
          const currencyIds = items.map((item) => item.currencyId)
          const allSameCurrency = currencyIds.every(
            (id) => id === currencyIds[0]
          )
          if (!allSameCurrency) {
            alert(this.$t('sale.sale_currency-must-be-same'))
            return
          }

          // キャンセル済みの注文が含まれていないかチェック
          const statusIds = items.map((item) => item.status)
          const isCanceled = statusIds.includes(99)
          if (isCanceled) {
            alert(this.$t('sale.sale_status-is-canceled'))
            return
          }

          items.forEach((item) => {
            if (!item.customerId) {
              alert(this.$t('sale.sale_customer-required'))
              return
            }
            if (!item.currencyId) {
              alert(this.$t('sale.sale_currency-required'))
              return
            }
          })

          this.dialogParams.dialog = true
          this.dialogParams.type = type
          this.dialogParams.items = items
          this.dialogParams.submitPath = '/api/order/ledger-sheet/combined-bill'
          this.dialogParams.submitFunc = this.getLedgerSheet
          this.dialogParams.billPeriodStart = this.saleDate.start
          this.dialogParams.billPeriodEnd = this.saleDate.end
          return
        }
        case 'csv': {
          // csvダウンロード
          const canDownload = items.every((item) => !item.shipDate)
          if (!canDownload) {
            alert(this.$t('sale.sale_contain-shipped-item'))
            return
          }
          const ids = items.map((d) => d.id).join(',')
          path = `/api/order/ledger-sheet/not-shiped?saleIds=${ids}`
          break
        }
        case 'saleHistoryCsv': {
          // csvダウンロード
          const ids = items.map((d) => d.id).join(',')
          const result = this.sendMailSalesCSV({
            saleIds: ids
          })
          if (result) {
            alert(
              this.$t(
                'common.common_csv-download-history-list-send-mail-message'
              )
            )
          }
          return
        }
        case 'orderHistoryCsv': {
          // csvダウンロード
          const ids = items.map((d) => d.id).join(',')
          const result = this.sendMailOrderCSV({
            orderIds: ids
          })
          if (result) {
            alert(
              this.$t(
                'common.common_csv-download-history-list-send-mail-message'
              )
            )
          }
          return
        }
        default: {
          break
        }
      }
      this.getLedgerSheet(path)
    },
    getCurrencyName(productInfo) {
      const currencyId = productInfo.currencyId
      if (currencyId) {
        return currencyUtil.findCurrencyNameById(currencyId).unitName
      }
      return ''
    },
    pageMove() {
      this.allChangeCheckBox = false
      this.selectRowInfo.selectRowlength = 0
      this.selectRowInfo.sumAmount = 0
      this.$emit('pageMove')
    },
    getProductTableItems(item) {
      let products
      if (item.orderEditHistoryId !== undefined) {
        products = item.orderEditHistoryProduct
      } else if (item.saleEditHistoryId !== undefined) {
        products = item.saleEditHistoryProduct
      } else {
        products = item.productMoves
      }
      if (
        this.summary.matchedProducts &&
        this.summary.matchedProducts.length > 0
      ) {
        const filterProductId = this.summary.matchedProducts[0].product_id
        return products.filter((product) => {
          return product.product.productId === filterProductId
        })
      } else {
        return products
      }
    },
    isRegistedOtherProduct(productMoves) {
      if (!this.summary.matchedProducts) {
        return false
      }
      if (!this.summary || this.summary.matchedProducts.length === 0) {
        return false
      }
      let flag = false
      productMoves.forEach((product) => {
        if (
          product.product.productId !==
          this.summary.matchedProducts[0].product_id
        ) {
          flag = true
        }
      })
      return flag
    },
    async fileSelected(event) {
      this.uploadFile = event.target.files[0]

      const formData = new FormData()
      formData.append('uploadFile', this.uploadFile)
      const uploadData = await this.fileUpload(formData)
      if (uploadData) {
        const nameListSuccess = uploadData.data.map((ele) => {
          if (ele.status == 'success') {
            return `${ele.sale_number} / ${ele.storage_id} \n`
          }
          return 
        })
        const nameListError = uploadData.data.map((ele) => {
          if (ele.status == 'error') {
            return `${ele.sale_number} / ${ele.storage_id} \n`
          }
          return 
        })
        //const nameListStr = nameListSuccess.join('\n')
        alert(`${this.$t('common.common_bulk-csv-ship-result')}
${nameListSuccess}
${this.$t('common.common_bulk-csv-ship-error')}
${nameListError}
        `)
        // 出庫履歴へ遷移
        this.$router.push({ name: 'sales.ship' })
      }

      this.$refs.file.value = '' // 初期化
    }
  },

  computed: {
    ...mapGetters('UI', ['pageInfo']),
    ...mapGetters('User', ['authority']),
    page: {
      get() {
        return this.pageInfo[this.pagerKey].page
      },
      set(index) {
        this[mutationTypes.UI_SET_PAGE]({ index, key: this.pagerKey })
      }
    },
    pageCount() {
      return this.pageInfo[this.pagerKey].pageCount
    },
    csvSampleUrl() {
      let url = ''
      switch (process.env.VUE_APP_ENV_NAME) {
        // TODO S3にテンプレートをアップロード
        case 'production':
          url =
            'https://order-assets.spe-s.com/sample/master-upload/bulk_ship_sample_20241017.zip'
          break
        case 'staging':
          url =
            'https://stg-order-assets.spe-s.com/sample/master-upload/bulk_ship_sample_20241017.zip'
          break
        default:
          url =
            'https://dev-order-assets.spe-s.com/sample/master-upload/bulk_ship_sample_20241017.zip'
      }
      return url
    }
  },

  watch: {
    historyList: function (val) {
      this.openPanelIndex = []
      this.setProductInfoData()
    },
    productInfoData: {
      deep: true,
      handler(newVal, oldVal) {
        this.updateProductInfoData()
      }
    }
  }
}
